import React from 'react';

const ImageIcon = ({ width = '38', height = '28', fill = '#BEBEBE' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 52 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.1573 45.9052C18.5399 45.9052 10.9225 45.9052 3.30508 45.9052C2.93298 45.9052 2.55606 45.9052 2.18236 45.8667C0.27533 45.6886 -0.49133 44.4039 0.321843 42.6669C1.02755 41.1673 1.79742 39.7061 2.54484 38.2225C6.0734 31.2371 9.60195 24.2526 13.1305 17.2693C13.2396 17.056 13.3535 16.8427 13.4802 16.639C14.3687 15.2147 15.8122 15.0142 16.9494 16.2428C17.7513 17.1025 18.4298 18.068 19.1451 18.9999C22.7806 23.7506 26.4161 28.5035 30.0516 33.2585C31.6394 35.3275 33.6395 35.4398 35.5048 33.5793C36.4302 32.6554 37.3348 31.7075 38.2715 30.7917C39.9604 29.1397 41.877 29.2391 43.2564 31.1654C46.0247 35.0308 48.7241 38.9475 51.4362 42.8514C51.6482 43.1576 51.8106 43.4954 51.9174 43.8522C52.1804 44.7488 51.8083 45.4705 50.8989 45.7095C50.3287 45.846 49.7433 45.9091 49.1571 45.8972C41.4948 45.91 33.8282 45.9127 26.1573 45.9052Z"
        fill={fill}
      />
      <path
        d="M43.2403 7.62834C43.2384 9.11934 42.7938 10.5762 41.9628 11.8142C41.1319 13.0522 39.9521 14.0156 38.573 14.5822C37.1939 15.1489 35.6775 15.2933 34.2162 14.9972C32.755 14.701 31.4145 13.9776 30.3648 12.9187C29.3152 11.8598 28.6036 10.5131 28.3202 9.04923C28.0369 7.5854 28.1945 6.0704 28.7733 4.6963C29.352 3.32219 30.3257 2.15087 31.5709 1.33082C32.8162 0.510776 34.2769 0.078937 35.7678 0.0900531C37.7532 0.115283 39.6491 0.919658 41.047 2.32978C42.4448 3.7399 43.2325 5.64282 43.2403 7.62834Z"
        fill={fill}
      />
    </svg>
  );
};

export default ImageIcon;
